/**
 * Envío AP-14 · límites de ENTRADA de los modelos (lo que aceptan como imagen o
 * video de entrada, no la duración de su salida) y su chequeo.
 */
const MB = 1024 * 1024;

export const INPUT_LIMITS = {
  dreamActor: {
    inputImage: { label: 'Dream Actor', kind: 'image', maxLong: 1920, maxShort: 1080, maxBytes: 4.7 * MB, preset: 'dreamActor', autoFix: true },
    inputVideo: { label: 'Dream Actor', kind: 'video', minSec: 3, maxSec: 30, maxBytes: 30 * MB, preset: 'dreamActor' },
  },
  videoWithSound: {
    videoInput: { label: 'Video con sonido', kind: 'video', maxSec: 8.7, preset: 'videoWithSound' },
  },
};

export const limitFor = (targetType, handle) => INPUT_LIMITS[targetType]?.[handle] || null;

const sec = (v) => `${String(Math.round(v * 10) / 10).replace('.', ',')} s`;
const mb = (b) => `${(b / MB).toFixed(1).replace('.', ',')} MB`;

/** Qué no cumple `info` ({width,height,bytes,duration}) para `spec`. Lista vacía = OK. */
export function limitProblems(info, spec) {
  if (!info || !spec) return [];
  const out = [];
  if (spec.kind === 'image' && info.width && info.height) {
    const long = Math.max(info.width, info.height); const short = Math.min(info.width, info.height);
    if (long > spec.maxLong || short > spec.maxShort) out.push(`${info.width}×${info.height} (acepta hasta ${spec.maxLong}×${spec.maxShort})`);
  }
  if (spec.kind === 'video' && info.duration) {
    if (spec.minSec && info.duration < spec.minSec - 0.05) out.push(`dura ${sec(info.duration)} (mínimo ${sec(spec.minSec)})`);
    if (spec.maxSec && info.duration > spec.maxSec + 0.05) out.push(`dura ${sec(info.duration)} (máximo ${sec(spec.maxSec)})`);
  }
  if (spec.maxBytes && info.bytes && info.bytes > spec.maxBytes) out.push(`pesa ${mb(info.bytes)} (máximo ${mb(spec.maxBytes)})`);
  return out;
}

/** El primer destino conectado que tiene problemas: {spec, problems} o null. */
export function firstLimitIssue(info, targets) {
  for (const { type, handle } of targets || []) {
    const spec = limitFor(type, handle);
    const problems = limitProblems(info, spec);
    if (spec && problems.length) return { spec, problems };
  }
  return null;
}
